<template>
  <div class="setting_container">
    <div class="setting_container_item setting_container_item_live_name">
      <div class="setting_title">直播名称</div>
      <div class="setting_content">
        <template v-if="!liveNameEditFlag">
          <span>{{ liveDetail.liveName || '- -' }}</span>
          <div class="edit_icon" @click="handleEditIcon" v-if="liveDetail.status === 0 || liveDetail.status === 1">
            <img src="@/assets/img/edit_icon.png" alt="编辑" />
          </div>
        </template>
        <template v-if="liveNameEditFlag">
          <a-input v-model:value="liveNameEdit" placeholder="请输入直播名称" style="flex: 1" />
          <div class="live_name_edit_cancel" @click="liveNameEditFlag = false">取消</div>
          <div class="live_name_edit_confirm" @click="handleLiveNameEditConfirm">确定</div>
        </template>
      </div>
    </div>
    <div class="setting_container_item">
      <div class="setting_title">直播ID</div>
      <div class="setting_content">
        {{ liveDetail.liveId || '- -' }}
      </div>
    </div>
    <div class="setting_container_item">
      <div class="setting_title">直播时间</div>
      <div class="setting_content">
        {{ liveTime }}
      </div>
    </div>
    <div class="setting_container_item">
      <div class="setting_title">主讲老师</div>
      <div class="setting_content">{{ liveDetail.username }}{{ liveDetail.phone ? `(${liveDetail.phone})` : '' }}</div>
    </div>
    <div class="setting_container_item">
      <div class="setting_title">导播人员</div>
      <div class="setting_content">
        {{ directors }}
      </div>
    </div>
    <div class="setting_container_item">
      <div class="setting_title">直播开关</div>
      <div class="setting_content live_switch_content">
        <a-checkbox
          v-model:checked="pushRtmp"
          @change="(e) => handlePushRtmpChange(e)"
          :disabled="liveDetail.status === 2"
        >
          开启RTMP直播
        </a-checkbox>
      </div>
    </div>
    <div class="setting_container_item">
      <div class="setting_title">观摩地址</div>
      <div :class="['setting_content observation_url_content', liveDetail.status === 2 ? 'disabled' : '']">
        <p class="url_content" @click="handleObserve">{{ classroomObservationUrl }}</p>
        <span class="copy_btn" @click="handleCopy">复制</span>
      </div>
    </div>
    <div class="setting_container_item">
      <div class="setting_title">直播状态</div>
      <div class="setting_content">
        <a-select
          :default-value="liveStatusDefault"
          :value="liveStatus"
          placeholder="直播状态"
          style="width: 160px"
          @change="handleStatusChange"
          :disabled="liveDetail.status !== 2"
        >
          <a-select-option
            :value="item.value"
            v-for="item in liveStreamingStatusOptions"
            :key="item.value"
            :disabled="item.disabled"
          >
            {{ item.title }}
          </a-select-option>
        </a-select>
      </div>
    </div>
    <div class="setting_container_item">
      <div class="setting_title">平台推流地址</div>
      <div class="setting_content platform_push_address">
        <a-input
          v-model:value="rtmpPushUrl"
          placeholder="请输入平台推流地址"
          style="flex: 1"
          @change="handleRtmpPushUrlChange"
          :disabled="liveDetail.status === 2"
        />
        <a-popover title="拉流地址" overlayClassName="popover_container" trigger="hover">
          <template slot="content" v-if="liveDetail.status !== 2">
            <div class="popover_container_inner">
              <p class="popover_item" @click="handleCopyPullUrl(pullUrlObj.rtmpPullUrl)">
                rtmp拉流地址：{{ pullUrlObj.rtmpPullUrl || '- -' }}
              </p>
              <p class="popover_item" @click="handleCopyPullUrl(pullUrlObj.flvPullUrl)">
                flv拉流地址：{{ pullUrlObj.flvPullUrl || '- -' }}
              </p>
              <p class="popover_item" @click="handleCopyPullUrl(pullUrlObj.hlsPullUrl)">
                hls拉流地址：{{ pullUrlObj.hlsPullUrl || '- -' }}
              </p>
            </div>
          </template>
          <span :class="['copy_btn', liveDetail.status === 2 ? 'disabled' : '']" @mouseover="handleShowPullUrl">
            显示拉流地址
          </span>
        </a-popover>
      </div>
    </div>
    <div class="setting_container_item three_company_push_url">
      <div class="setting_title">第三方推流地址</div>
      <div class="setting_content">
        <a-textarea
          v-model:value="threeCompanyPushUrl"
          @change="handleThreeCompanyPushUrlChange"
          placeholder="请输入第三方推流地址，地址间请用;分割"
          :rows="4"
          style="width: 360px; resize: none"
          :disabled="liveDetail.status === 2"
        />
      </div>
    </div>
    <div class="setting_container_item">
      <div class="setting_title">直播延迟</div>
      <div class="setting_content live_delay">
        <a-switch
          :checked="liveDelaySwitch"
          @change="handleLiveDelayCheckedChange"
          style="margin-right: 16px"
          :disabled="liveDetail.status === 2"
        />
        <template v-if="liveDelaySwitch">
          <a-input
            v-model:value="liveDelayTime"
            @change="handleLiveDelayTimeChange"
            type="number"
            placeholder="请输入"
            style="width: 80px"
            :disabled="liveDetail.status === 2"
          />
          <span class="second">秒</span>
          <span class="body_item_content_explain">请输入15-3600之间的整数</span>
        </template>
      </div>
    </div>
    <div class="setting_container_item">
      <div class="setting_title">课间展示图片</div>
      <div class="setting_content pictures_show_between_classes">
        <div
          :class="`body_item_content_upload ${imageUrl ? 'has-image' : ''}`"
          :style="`background-image: url('${imageUrl}')`"
        >
          <div class="update-mask">
            <i :class="`icon-upload ${uploadLoading ? 'icon-loading' : ''} `"></i>
            <span class="btn-text">{{ uploadLoading ? '上传中...' : '自定义上传' }}</span>
          </div>
          <div class="update-wrap" :style="`display:${uploadLoading ? 'none' : 'block'}`">
            <UploadImg @updateUpload="updateUpload" />
          </div>
          <!-- <div
            v-if="liveDetail.status === 2"
            style="
              width: 100%;
              height: 100%;
              position: absolute;
              background-color: rgba(255, 255, 255, 0.1);
              cursor: not-allowed;
              z-index: 9999;
            "
          ></div> -->
          <div
            style="
              width: 100%;
              height: 100%;
              position: absolute;
              background-color: rgba(255, 255, 255, 0.1);
              cursor: not-allowed;
              z-index: 9999;
            "
          ></div>
        </div>
        <div class="body_item_content_explain">建议尺寸16:9，格式为png/jpg/gif，图片不超过5M。</div>
      </div>
    </div>
    <div class="setting_container_item">
      <div class="setting_title">暂停直播</div>
      <div class="setting_content suspend_live_streaming">
        <p
          :class="['live_stream_control', liveStreamControlClassName]"
          @click="handleLiveStreamControl"
          v-if="classroomInspectionDetailInfo.liveSource === 3"
        >
          <img v-if="liveStreamControlFlag" :src="liveStreamControlIcon" alt="直播控制" />
          <span>{{ liveStreamControlTitle }}</span>
        </p>
      </div>
    </div>
    <div class="setting_container_item">
      <div class="setting_title">屏幕共享</div>
      <div class="setting_content">
        <p :class="['share_screen_control', shareScreenControlClassName]" @click="handleShareScreen">
          <img
            src="https://image.zhihuishu.com/zhs/b2cm/base1/202309/153b3c5d29ba4c24b2bc1361742cb64a.png"
            alt="共享屏幕"
          />
          <span>{{ shareScreenControlTitle }}</span>
        </p>
      </div>
    </div>
    <div class="loading_mask" v-if="loadingFlag">
      <a-spin />
    </div>
  </div>
</template>

<script>
import UploadImg from '@/views/CourseManagement/activity/comp/UploadImg.vue'
import { ROLE } from '@/consts/user'
export default {
  name: 'LiveSettingTab', // 右侧导播台tab
  props: {
    liveId: String | Number,
    classroomList: {
      type: Array,
      default: []
    },
    liveDetail: {
      type: Object,
      default() {
        return {}
      }
    },
    clientForZRTC: {
      type: Object | null,
      default: null
    }
  },
  computed: {
    liveTime: function () {
      if (!Object.keys(this.liveDetail).length) return ''
      const { startTime, endTime } = this.liveDetail
      const date = startTime.split(' ')[0].replace(/-/g, '/')
      const startTimeNew = startTime.split(' ')[1].slice(0, 5)
      const endTimeNew = endTime.split(' ')[1].slice(0, 5)
      const liveTime = date + ' ' + startTimeNew + '-' + endTimeNew
      return liveTime
    },
    directors: function () {
      const { directors } = this.liveDetail
      return (directors || []).join('、') || '- -'
    },
    classroomObservationUrl: function () {
      // return `https://tju-livecourse.zhihuishu.com/teacher/IndividualStudent?liveId=${this.liveId}`
      return `https://zhs-livecourse.zhihuishu.com/teacher/IndividualStudent?liveId=${this.liveId}`
    },
    liveStreamControlClassName: function () {
      if (!this.cdnViewSettingInfo.pushRtmp) return 'gray'
      if (this.cdnViewSettingInfo.stopLive) return 'orange'
      return ''
    },
    liveStreamControlFlag: function () {
      if (!this.cdnViewSettingInfo.pushRtmp) return false
      return true
    },
    liveStreamControlIcon: function () {
      if (!this.cdnViewSettingInfo.pushRtmp) return ''
      if (this.cdnViewSettingInfo.stopLive)
        return 'https://image.zhihuishu.com/zhs/b2cm/base1/202309/cf61316c8aec44e4b31ba0e224eadfb8.png'
      return 'https://image.zhihuishu.com/zhs/b2cm/base1/202309/c6873bd3d2624488a215d949b76b56b5.png'
    },
    liveStreamControlTitle: function () {
      if (!this.cdnViewSettingInfo.pushRtmp) return '未开启直播'
      if (this.cdnViewSettingInfo.stopLive) return '继续直播'
      return '暂停直播'
    },
    shareScreenControlClassName: function () {
      if (this.liveDetail.status === 2) return 'gray'
      const shareScreenItem = (this.classroomList || []).find((item) => item.role === ROLE.SHARE_SCREEN)
      if (!shareScreenItem) return 'orange'
      return ''
    },
    shareScreenControlTitle: function () {
      const shareScreenItem = (this.classroomList || []).find((item) => item.role === ROLE.SHARE_SCREEN)
      if (!shareScreenItem) return '开启共享'
      return '停止共享'
    }
  },
  components: {
    UploadImg
  },
  data() {
    return {
      pushRtmp: false,
      liveStreamingStatusOptions: [
        {
          title: '待开始',
          value: 0,
          disabled: false
        },
        {
          title: '进行中',
          value: 1,
          disabled: true
        },
        {
          title: '已结束',
          value: 2,
          disabled: false
        }
      ],
      liveStatus: '',
      liveStatusDefault: undefined,
      rtmpPushUrl: '',
      pullUrlObj: {},
      threeCompanyPushUrl: '',
      liveDelaySwitch: false,
      liveDelayTime: '',
      imageUrl: '',
      uploadLoading: false,
      classroomInspectionDetailInfo: {},
      cdnViewSettingInfo: {},
      loadingFlag: false,
      timerIdSetRtmpPushUrl: null,
      timerIdSetThreeCompanyPushUrl: null,
      timerIdSetLiveDelayTime: null,
      liveNameEditFlag: false,
      liveNameEdit: ''
    }
  },
  watch: {
    liveDetail: {
      handler(newVal) {
        if (!Object.keys(newVal).length) return
        this.liveStatus = newVal.status
      },
      deep: true,
      immediate: true
    },
    classroomList: {
      handler(newVal) {
        if ((newVal || []).length) {
          this.getClassroomInspectionDetail()
        }
      },
      deep: true
    }
  },
  methods: {
    handlePushRtmpChange(e) {
      this.handleConfirm('pushRtmp')
    },

    handleRtmpPushUrlChange(e) {
      if (this.timerIdSetRtmpPushUrl) clearTimeout(this.timerIdSetRtmpPushUrl)
      this.timerIdSetRtmpPushUrl = setTimeout(() => {
        this.handleConfirm('rtmpPushUrl')
      }, 500)
    },

    handleThreeCompanyPushUrlChange(e) {
      if (this.timerIdSetThreeCompanyPushUrl) clearTimeout(this.timerIdSetThreeCompanyPushUrl)
      this.timerIdSetThreeCompanyPushUrl = setTimeout(() => {
        this.handleConfirm('threeCompanyPushUrl')
      }, 500)
    },
    handleLiveDelayTimeChange(e) {
      console.log(this.liveDelayTime, 'liveDelayTime_liveDelayTime__liveDelayTime')
      if (this.timerIdSetLiveDelayTime) clearTimeout(this.timerIdSetLiveDelayTime)
      this.timerIdSetLiveDelayTime = setTimeout(() => {
        this.handleConfirm('liveDelayTime')
      }, 500)
    },
    handleObserve() {
      if (this.liveDetail.status === 2) return
      window.open(this.classroomObservationUrl, '_blank')
    },
    handleCopy() {
      if (this.liveDetail.status === 2) return
      this.$copyText(this.classroomObservationUrl).then(
        () => {
          this.$message.success('复制成功!')
        },
        () => {
          this.$message.error('复制失败!')
        }
      )
    },
    resetPushRtmp() {
      this.pushRtmp = this.cdnViewSettingInfo.pushRtmp
    },
    resetLiveStatus() {
      this.liveStatus = this.liveDetail.status
    },
    resetRtmpPushUrl() {
      this.rtmpPushUrl = this.cdnViewSettingInfo.cdnPushUrl
    },
    resetThreeCompanyPushUrl() {
      this.threeCompanyPushUrl = this.cdnViewSettingInfo.threeCompanyPushUrl
    },
    resetSetLiveDelayTime() {
      this.liveDelayTime = this.cdnViewSettingInfo.liveDelayTime
    },
    resetImageUrl() {
      this.imageUrl = this.cdnViewSettingInfo.image
    },
    async handleStatusChange(value) {
      this.liveStatus = value
      const params = {
        liveId: this.liveId
      }
      try {
        const result = await this.$http.cloudCasterResetLive(params)
        if (result.code !== 200) {
          this.resetLiveStatus()
          return this.$message.error('抱歉，设置失败')
        }
        if (result.rt) {
          const { rt: resultReally } = result
          if (resultReally.resultStatus !== 1) {
            this.resetLiveStatus()
            return this.$message.error(resultReally.resultMessage || '抱歉，设置失败')
          }
        }
        this.$emit('getLiveDetail')
      } catch (err) {
        console.log(err)
      }
    },
    handleCopyPullUrl(url) {
      if (!url) return
      this.$copyText(url).then(
        () => {
          this.$message.success('复制成功!')
        },
        () => {
          this.$message.error('复制失败!')
        }
      )
    },
    async handleShowPullUrl() {
      if (!this.rtmpPushUrl) return
      try {
        const params = {
          liveId: this.liveId,
          cdnPushUrl: this.rtmpPushUrl
        }
        const result = await this.$http.livesettingCdnPullUrlGet(params)
        if (result.code !== 200) return
        this.pullUrlObj = result.rt || {}
      } catch (err) {
        console.log(err)
      }
    },
    handleLiveDelayCheckedChange(checked) {
      this.liveDelaySwitch = checked
      if (checked) this.liveDelayTime = 300
      this.handleConfirm('liveDelaySwitch_and_liveDelayTime')
    },
    updateUpload(obj = {}) {
      this.imageUrl = obj.imageUrl || this.imageUrl
      this.uploadLoading = obj.loading
      if (!obj.loading) {
        this.handleConfirm('imageUrl')
      }
    },
    async handleLiveStreamControl() {
      try {
        if (!this.cdnViewSettingInfo.pushRtmp) return
        const params = {
          liveId: this.liveId,
          stopLive: this.cdnViewSettingInfo.stopLive ? 2 : 1
        }
        const result = await this.$http.livesettingContinueOrStopLive(params)
        if (result.code !== 200) return this.$message.error(result.msg || '抱歉，设置失败')
        this.$message.success('设置成功')
        this.getCdnViewSettingInfo()
      } catch (err) {
        console.log(err)
      }
    },
    sendCustomSignal(txType, content) {
      const { socketId } = this.classroomInspectionDetailInfo
      if (this.clientForZRTC.sendCustomSignal) {
        this.clientForZRTC.sendCustomSignal({
          txType,
          to: socketId,
          content: {
            ...content
          }
        })
      }
    },
    handleShareScreen() {
      if (this.liveDetail.status === 2) return
      let operationType = ''
      switch (this.shareScreenControlTitle) {
        case '开启共享':
          operationType = 'start-screen-share'
          break
        case '停止共享':
          operationType = 'stop-screen-share'
          break
      }
      this.sendCustomSignal('remote-control', {
        operationType
      })
    },
    async getClassroomInspectionDetail() {
      try {
        const speakItem = this.classroomList.find((item) => item.role === ROLE.SPEAKER)
        if (!speakItem) return
        const params = {
          liveId: this.liveId,
          classroomCode: speakItem.classroomId
        }
        const result = await this.$http.classroomInspectionDetail(params)
        if (result.code !== 200) return
        this.classroomInspectionDetailInfo = result.rt || {}
      } catch (err) {
        console.log(err)
      }
    },
    async getCdnViewSettingInfo() {
      try {
        const params = {
          liveId: this.liveId
        }
        const result = await this.$http.livesettingCdnViewSettingGet(params)
        if (result.code !== 200) return
        this.cdnViewSettingInfo = result.rt || {}
        const { pushRtmp, liveDelayTime, image, cdnPushUrl, threeCompanyPushUrl, liveDelaySwitch } =
          this.cdnViewSettingInfo
        this.pushRtmp = pushRtmp
        this.rtmpPushUrl = cdnPushUrl
        this.threeCompanyPushUrl = threeCompanyPushUrl || ''
        this.liveDelaySwitch = liveDelaySwitch || false
        this.liveDelayTime = liveDelayTime || ''
        this.imageUrl = image || ''
      } catch (err) {
        console.log(err)
      }
    },
    isInteger(num) {
      return (num | 0) === num
    },
    async handleConfirm(where) {
      try {
        if (this.liveDelaySwitch) {
          if (!this.liveDelayTime) {
            if (where === 'pushRtmp') {
              this.resetPushRtmp()
            }
            if (where === 'liveDelayTime') {
              this.resetSetLiveDelayTime()
            }
            return this.$message.error('请输入直播延迟时间')
          }
          if (
            !this.isInteger(Number(this.liveDelayTime)) ||
            Number(this.liveDelayTime) < 15 ||
            Number(this.liveDelayTime) > 3600
          ) {
            if (where === 'pushRtmp') {
              this.resetPushRtmp()
            }
            if (where === 'liveDelayTime') {
              this.resetSetLiveDelayTime()
            }
            return this.$message.error('请输入15-3600之间的整数')
          }
        }
        this.loadingFlag = true
        const params = {
          liveId: this.liveId,
          pushRtmp: this.pushRtmp,
          liveDelayTime: parseInt(this.liveDelayTime || 0),
          image: this.imageUrl,
          rtmpPushUrl: this.rtmpPushUrl,
          threeCompanyPushUrl: this.threeCompanyPushUrl,
          liveDelaySwitch: this.liveDelaySwitch
        }
        const result = await this.$http.livesettingCdnViewSetting(params)
        if (result.code !== 200) {
          this.loadingFlag = false
          if (where === 'rtmpPushUrl') {
            this.resetRtmpPushUrl()
          }
          if (where === 'threeCompanyPushUrl') {
            this.resetThreeCompanyPushUrl()
          }
          if (where === 'liveDelayTime') {
            this.resetSetLiveDelayTime()
          }
          if (where === 'imageUrl') {
            this.resetImageUrl()
          }
          return this.$message.error(result.msg || '抱歉，设置失败')
        }
        let { rt: resultReally } = result
        if (resultReally.resultStatus !== 1) {
          this.loadingFlag = false
          if (where === 'rtmpPushUrl') {
            this.resetRtmpPushUrl()
          }
          if (where === 'threeCompanyPushUrl') {
            this.resetThreeCompanyPushUrl()
          }
          if (where === 'liveDelayTime') {
            this.resetSetLiveDelayTime()
          }
          if (where === 'imageUrl') {
            this.resetImageUrl()
          }
          return this.$message.error(resultReally.resultMessage || '抱歉，设置失败')
        }
        this.loadingFlag = false
        this.$message.success('设置成功')
        this.getCdnViewSettingInfo()
      } catch (err) {
        console.log(err)
      }
    },
    handleEditIcon() {
      this.liveNameEditFlag = true
      this.liveNameEdit = this.liveDetail.liveName
    },
    async handleLiveNameEditConfirm() {
      try {
        const params = {
          liveId: this.liveDetail.liveId,
          liveName: this.liveNameEdit
        }
        const result = await this.$http.updateLiveInfo(params)
        if (result.code !== 200) return this.$message.error(result.msg || '抱歉，编辑失败')
        this.$message.success('编辑成功')
        this.$emit('getLiveDetail')
        this.liveNameEdit = ''
        this.liveNameEditFlag = false
      } catch (err) {
        console.log(err)
      }
    }
  },
  created() {
    this.getCdnViewSettingInfo()
  }
}
</script>

<style lang="scss" scoped>
@keyframes loadingAni {
  0% {
    transform: rotate(-180deg);
  }
  100% {
    transform: rotate(180deg);
  }
}
.setting_container {
  width: 100%;
  height: auto;
  padding: 12px 20px 0;
  position: relative;
  .setting_container_item {
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-bottom: 16px;
    .setting_title {
      width: 100px;
      text-align: right;
      margin-right: 16px;
      font-weight: 500;
      color: #1e2228;
    }
    &.three_company_push_url {
      align-items: flex-start;
    }
    .setting_content {
      color: #6f7c91;
      flex: 1;
      text-align: left;
      &.live_switch_content {
        ::v-deep.ant-checkbox-wrapper {
          color: #6f7c91;
        }
      }
      .copy_btn {
        color: #3982ff;
        margin-left: 8px;
        cursor: pointer;
        user-select: none;
        &:hover {
          color: #306fdc;
        }
        &:active {
          color: #3982ff;
        }
        &.disabled {
          color: #c2c2c2;
          cursor: not-allowed;
        }
      }
      &.observation_url_content {
        display: flex;
        align-items: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        .url_content {
          flex: 1;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: #3982ff;
          cursor: pointer;
        }
        &.disabled {
          .url_content {
            color: #c2c2c2;
            cursor: not-allowed;
          }
          .copy_btn {
            color: #c2c2c2;
            cursor: not-allowed;
          }
        }
      }
      &.platform_push_address {
        display: flex;
        align-items: center;
      }
      &.live_delay {
        .second {
          margin: 0 8px;
        }
        .body_item_content_explain {
          font-size: 12px;
          color: #9fa2b1;
        }
      }
      &.pictures_show_between_classes {
        .body_item_content_upload {
          width: 160px;
          height: 90px;
          position: relative;
          border-radius: 2px;
          border: 1px solid #dcdee0;
          background: #f6f8fa;
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center center;
          margin-bottom: 8px;
          .update-mask {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            line-height: 30px;
            .icon-upload {
              display: inline-block;
              width: 24px;
              height: 24px;
              background: url('../../../assets/img/icon-plus2@2x.png') no-repeat;
              background-size: cover;
              &.icon-loading {
                background: none;
                border: 2px solid #969799;
                border-left: 2px solid transparent;
                border-radius: 100%;
                animation: loadingAni infinite 1s linear;
              }
            }
            .btn-text {
              color: #969799;
              margin: 0;
            }
          }
          .update-wrap {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            cursor: pointer;
            z-index: 1;
          }
          &.has-image {
            .update-mask {
              background-color: rgba(0, 0, 0, 0.5);
            }
            .btn-text {
              color: #fff;
            }
            .icon-upload {
              background-image: url('../../../assets/img/icon-plus3@2x.png');
              &.icon-loading {
                border: 2px solid #fff;
                border-left: 2px solid transparent;
              }
            }
          }
        }
        .body_item_content_explain {
          font-size: 12px;
          color: #9fa2b1;
        }
      }
      &.suspend_live_streaming {
      }
      .live_stream_control,
      .share_screen_control {
        width: 96px;
        background: #5f60d3;
        border-radius: 14px;
        font-size: 12px;
        font-weight: 500;
        color: #eaedf0;
        line-height: 28px;
        text-align: center;
        user-select: none;
        cursor: pointer;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          background: #4c4eaf;
        }
        &:active {
          background: #5f60d3;
        }
        &.gray {
          background: #eceef3;
          color: #afb1b8;
          cursor: not-allowed;
          &:hover {
            background: #eceef3;
          }
          &:active {
            background: #eceef3;
          }
        }
        &.orange {
          background: #fb6f33;
          &:hover {
            background: #d65c27;
          }
          &:active {
            background: #fb6f33;
          }
        }
        img {
          width: 12px;
          height: 12px;
          display: block;
          margin-right: 4px;
        }
      }
    }
    &.setting_container_item_live_name {
      .setting_content {
        display: flex;
        align-items: center;
        .edit_icon {
          width: 16px;
          height: 16px;
          margin-left: 8px;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
            display: block;
          }
          &:hover {
            background-color: #f5f5f5;
          }
          &:active {
            background-color: #fff;
          }
        }
        .live_name_edit_cancel,
        .live_name_edit_confirm {
          width: 70px;
          height: 25px;
          border: 1px solid #3982ff;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: 16px;
          border-radius: 5px;
          cursor: pointer;
          &:hover {
            background-color: #f5f5f5;
          }
          &:active {
            background-color: #fff;
          }
        }
        .live_name_edit_cancel {
          border-color: #6f7c91;
        }
        .live_name_edit_confirm {
          color: #3982ff;
          margin-left: 8px;
        }
      }
    }
  }
  .loading_mask {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.7);
    cursor: not-allowed;
  }
}
</style>
